const pageSeo = {
  title: 'Colorificio Postumia a Oderzo e S. Donà di Piave | I professionisti del colore',
  description: 'Da oltre 30 offriamo una gamma completa di prodotti per muro, ferro e legno per professionisti, industrie e fai da te, con la consulenza dei nostri esperti.'
}
export default pageSeo
